 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~affc7fa4":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~affc7fa4","metrics":"metrics","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~bb59e5e8":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~bb59e5e8","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c0ed185f":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c0ed185f","account~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-readlists~brows~760520bc":"account~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-readlists~brows~760520bc","account":"account","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","duplicate-pages":"duplicate-pages","history":"history","home":"home","import-books":"import-books","import-readlist":"import-readlist","read-book":"read-book","settings-users":"settings-users","browse-book~search":"browse-book~search","browse-book":"browse-book","search":"search","duplicate-files~login~media-analysis~settings-user":"duplicate-files~login~media-analysis~settings-user","duplicate-files":"duplicate-files","login":"login","media-analysis":"media-analysis","settings-user":"settings-user","settings-server":"settings-server","import~media-management~settings":"import~media-management~settings","import":"import","media-management":"media-management","settings":"settings","notfound":"notfound","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~affc7fa4":"299955ac","metrics":"62275bd8","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~bb59e5e8":"1b889aa4","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c0ed185f":"ddbd640d","account~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-readlists~brows~760520bc":"041941cf","account":"2bd94a90","browse-collection":"eb3a315f","browse-collections":"6b49dae8","browse-libraries":"305554ed","browse-readlist":"4dc21a94","browse-readlists":"7c45559f","browse-series":"2b0cb6f4","dashboard":"b466ad78","duplicate-pages":"d6bd595e","history":"2891122a","home":"789cef97","import-books":"114c6679","import-readlist":"7a0785b6","read-book":"d99de52a","settings-users":"f477d78d","browse-book~search":"0a3313d1","browse-book":"937d05e7","search":"0588c614","duplicate-files~login~media-analysis~settings-user":"22d77f44","duplicate-files":"ec3c4591","login":"299a4fbe","media-analysis":"3b2ff180","settings-user":"9721767b","settings-server":"af5a838b","import~media-management~settings":"7ec3e399","import":"3b48c42e","media-management":"44e5629c","settings":"7e924dc7","notfound":"4b0509e4","welcome":"4ee14c06","startup":"c1e2b815"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~affc7fa4":1,"metrics":1,"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~bb59e5e8":1,"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c0ed185f":1,"account~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-readlists~brows~760520bc":1,"account":1,"browse-collection":1,"browse-collections":1,"browse-libraries":1,"browse-readlist":1,"browse-readlists":1,"browse-series":1,"dashboard":1,"duplicate-pages":1,"history":1,"home":1,"import-books":1,"import-readlist":1,"read-book":1,"settings-users":1,"browse-book~search":1,"browse-book":1,"search":1,"duplicate-files~login~media-analysis~settings-user":1,"duplicate-files":1,"login":1,"media-analysis":1,"settings-user":1,"settings-server":1,"import~media-management~settings":1,"import":1,"media-management":1,"settings":1,"notfound":1,"welcome":1,"startup":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~affc7fa4":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~affc7fa4","metrics":"metrics","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~bb59e5e8":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~bb59e5e8","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c0ed185f":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c0ed185f","account~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-readlists~brows~760520bc":"account~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-readlists~brows~760520bc","account":"account","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","duplicate-pages":"duplicate-pages","history":"history","home":"home","import-books":"import-books","import-readlist":"import-readlist","read-book":"read-book","settings-users":"settings-users","browse-book~search":"browse-book~search","browse-book":"browse-book","search":"search","duplicate-files~login~media-analysis~settings-user":"duplicate-files~login~media-analysis~settings-user","duplicate-files":"duplicate-files","login":"login","media-analysis":"media-analysis","settings-user":"settings-user","settings-server":"settings-server","import~media-management~settings":"import~media-management~settings","import":"import","media-management":"media-management","settings":"settings","notfound":"notfound","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~affc7fa4":"aaab1f3f","metrics":"9a757846","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~bb59e5e8":"8900c3e4","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-rea~c0ed185f":"a92ebaa2","account~browse-collection~browse-collections~browse-libraries~browse-readlist~browse-readlists~brows~760520bc":"13b6c764","account":"eaf00d72","browse-collection":"d515aa5d","browse-collections":"c8914128","browse-libraries":"77a96028","browse-readlist":"52ec3b1b","browse-readlists":"c8914128","browse-series":"e027d0c3","dashboard":"fc36dcb0","duplicate-pages":"4f74abc6","history":"b7338055","home":"b8e03304","import-books":"7008f8ed","import-readlist":"612c80f8","read-book":"c847fd81","settings-users":"b7e8f451","browse-book~search":"4afc88dd","browse-book":"d7710624","search":"3b468b63","duplicate-files~login~media-analysis~settings-user":"b9c188cd","duplicate-files":"0e639525","login":"6ff17e96","media-analysis":"0e639525","settings-user":"91bdac8b","settings-server":"9feda2b9","import~media-management~settings":"7df717b5","import":"878ad2e3","media-management":"df1b70ce","settings":"878ad2e3","notfound":"5cff8ae2","welcome":"7cc5818c","startup":"7cc5818c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
